export const URL = process.env.API_URL;
export const FILES_URL = process.env.API_FILES_URL;
